'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

var _index = /*#__PURE__*/require('./index');

/**
 * Returns a singleton array containing the value provided.
 * If value is already an array, it is returned as is.
 *
 * @func ensureArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.6.0|v2.6.0}
 * @category List
 * @sig a | [a] -> [a]
 * @param {*|Array} val the value ensure as Array
 * @return {Array}
 * @see {@link http://ramdajs.com/docs/#of|R.of}
 * @example
 *
 * RA.ensureArray(42); //=> [42]
 * RA.ensureArray([42]); //=> [42]
 */
var ensureArray = /*#__PURE__*/(0, _ramda.when)(_index.isNotArray, _ramda.of);

exports.default = ensureArray;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/ensureArray.js
// module id = 869
// module chunks = 168707334958949